(() => {
  const initCart = (root) => {
    if (root.dataset.cartInitialized === 'true') return;

    const form = root.querySelector('[data-sh-cart-form]');
    if (!form) return;

    root.dataset.cartInitialized = 'true';

    const submitUpdate = () => {
      root.setAttribute('aria-busy', 'true');
      form.requestSubmit();
    };

    root.querySelectorAll('[data-cart-quantity]').forEach((control) => {
      const input = control.querySelector('[data-cart-quantity-input]');
      const decrease = control.querySelector('[data-cart-quantity-action="decrease"]');
      const increase = control.querySelector('[data-cart-quantity-action="increase"]');
      if (!input || !decrease || !increase) return;

      const readNumber = (value, fallback) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const syncButtons = () => {
        const value = readNumber(input.value, 0);
        const min = readNumber(input.min, 0);
        const max = input.max === '' ? Infinity : readNumber(input.max, Infinity);
        decrease.disabled = value <= min;
        increase.disabled = value >= max;
      };

      const changeQuantity = (direction) => {
        const value = readNumber(input.value, 0);
        const step = Math.max(readNumber(input.step, 1), 1);
        const min = readNumber(input.min, 0);
        const max = input.max === '' ? Infinity : readNumber(input.max, Infinity);
        const nextValue = Math.min(max, Math.max(min, value + direction * step));

        if (nextValue === value) return;
        input.value = String(nextValue);
        syncButtons();
        submitUpdate();
      };

      decrease.addEventListener('click', () => changeQuantity(-1));
      increase.addEventListener('click', () => changeQuantity(1));
      input.addEventListener('change', () => {
        syncButtons();
        submitUpdate();
      });
      syncButtons();
    });
  };

  const initAllCarts = () => {
    document.querySelectorAll('[data-sh-cart-page]').forEach(initCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarts, { once: true });
  } else {
    initAllCarts();
  }

  document.addEventListener('shopify:section:load', initAllCarts);
})();
